<template>
  <div class="menu">
    <template v-if="list.length > 0">
      <div class="list_item" v-for="(item, i) in list" :key="i" @click="pushNext(item.title)">
        <div class="img">
          <img :src="item.picture" alt="" />
        </div>
        <div class="main">
          <div class="title">{{ item.title }}</div>
          <!-- <div class="date">{{ item.createDate }}</div> -->
        </div>
      </div>
    </template>
    <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无奖品哦~"
    />
  </div>
</template>

<script>
import { getUserActivityWinner } from "@/api/draw.js";
import { drawrule } from "@/api/draw.js";
import { Toast } from "vant";

export default {
  data() {
    return {
      list:[
		  {
			title:'参与抽奖',
			picture:require('../../../images/drawactivity/canyuchoujiang.png')
		  },
		  {
			title:'下期预告',
			picture:require('../../../images/drawactivity/xiaqiyugao.png')
		  },
		  {
			title:'往期活动',
			picture:require('../../../images/drawactivity/wangqihuodong.png')
		  },
		  {
			title:'我的奖品',
			picture:require('../../../images/drawactivity/wodejiangpin.png')
		  }],
    };
	this.list = [
		  {
			title:'参与抽奖',
			picture:require('../../../images/drawactivity/canyuchoujiang.png')
		  },
		  {
			title:'下期预告',
			picture:require('../../../images/drawactivity/xiaqiyugao.png')
		  },
		  {
			title:'往期活动',
			picture:require('../../../images/drawactivity/wangqihuodong.png')
		  },
		  {
			title:'我的奖品',
			picture:require('../../../images/drawactivity/wodejiangpin.png')
		  }];
  },
  methods:{
	  pushNext(title){
		  if(title == '参与抽奖'){
			  console.log(title);			  			  
			  this.getData(this.$cookies.get("internetBarId"));
		  }
		  else if (title == '下期预告'){
			   console.log(title);
			   this.$router.push({ path: "/NextActivityList" });
		  }
		  else if (title == '往期活动'){
			   console.log(title);
			   this.$router.push({ path: "/HistoryActivityList" });
		  }
		  else if (title == '我的奖品'){
			   console.log(title);
			   this.$router.push({
			     path: '/myprize',
			     query: {
			       type:2
			     },
			   });
		  }
		  // this.$router.push({
		  //   path: "/detailswarranty",
		  //   query: { maintenanceFormId: maintenanceFormId },
		  // });
	  },
	  async getData(internetBarId) {
	    try {
	      const data = await drawrule({ internetBarId });
	      console.log(data);
		  console.log(data.data==null);
	      if (data.data == null) {
			  console.log("暂无可参与的活动");
	        Toast(data.message);
	      } else {
	        this.$router.push({ path: "/drawactivity" });
	      }
	    } catch (e) {
			
		}
	  },
  }
};
</script>
<style lang="scss" scoped>
/deep/ .custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
div {
  box-sizing: border-box;
}
img {
  width: 100%;
  height: 100%;
}
.menu {
  width: 100%;
  height: 100%;
  padding: 10px 13px;
  background-color: #f6f6f6;
  .list_item {
    margin-top: 10px;
    width: 100%;
    border-radius: 8px;
    height: 60px;
    background-color: #fcfcfc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    .img {
      width: 40px;
      height: 40px;
      overflow: hidden;
    }
    .main {
      margin-left: 10px;
      flex: 1;
      height: 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      text-align: left;
      .title {
        width: 100%;
        text-align: left;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      // .date {
      //   width: 100%;
      //   text-align: left;
      //   font-size: 14px;
      //   font-family: PingFang SC;
      //   font-weight: 500;
      //   color: #999999;
      // }
    }
  }
}
</style>
<style>
.van-empty {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: transform 0.3s;
}
.van-empty__description {
  width: 100%;
}
</style>
